module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel box-collapse border-color-skin",
    attrs: {
      "id": "hrms75e-detail-tab2"
    }
  }, [_c('div', {
    staticClass: "box-header with-border box-header-collapse collapsed  tab-header",
    attrs: {
      "data-toggle": "collapse",
      "data-parent": "#accordion",
      "href": "#tab2"
    }
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('i', {
    staticClass: "fa fa-file-text-o margin-r-5 margin-r-5"
  }), _vm._v(_vm._s(_vm.labels['HRMS75EC3']['10']) + "\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse tab-detail",
    attrs: {
      "id": "tab2"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "detail detail-responsive panel-detail-filter"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group margin-b-5"
  }, [_c('label', {
    staticClass: "col-md-4 control-label"
  }, [_vm._v(_vm._s(_vm.labels['HRMS75EC3']['20']))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-control readonly-field-color"
  }, [_vm._v(_vm._s(_vm.detail.detail.desc_codempid))])])])]), _vm._v(" "), _c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group margin-b-5"
  }, [_c('label', {
    staticClass: "col-md-4 control-label"
  }, [_vm._v(_vm._s(_vm.labels['HRMS75EC3']['30']))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-control readonly-field-color"
  }, [_vm._v(_vm._s(_vm.detail.detail.desc_codcomp))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group margin-b-5"
  }, [_c('label', {
    staticClass: "col-md-4 control-label"
  }, [_vm._v(_vm._s(_vm.labels['HRMS75EC3']['40']))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-control readonly-field-color"
  }, [_vm._v(_vm._s(_vm.detail.detail.desc_codpos))])])])]), _vm._v(" "), _c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group margin-b-5"
  }, [_c('label', {
    staticClass: "col-md-4 control-label"
  }, [_vm._v(_vm._s(_vm.labels['HRMS75EC3']['50']))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-control readonly-field-color"
  }, [_vm._v(_vm._s(_vm.detail.detail.desc_codjob))])])])])]), _vm._v(" "), _c('hrms-table', {
    ref: "detailTab2Table",
    attrs: {
      "columns": _vm.detailTab2Columns,
      "data": _vm.detail.table,
      "selectRowBool": false,
      "selectBtnDisp": true,
      "selectEvent": _vm.selectEvent,
      "confirmSelectBtnDisp": false
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 "
  }, [_c('button', {
    staticClass: "btn bg-color-skin pull-right",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.togglePopupDetailTab2()
      }
    }
  }, [_vm._v(_vm._s(_vm.labels['HRMS75EC3']['130']))]), _vm._v(" "), _c('button', {
    ref: "detailTab2TableBtn",
    attrs: {
      "type": "button",
      "hidden": "",
      "data-toggle": "modal",
      "data-target": "#hrms75e-popup-tab2"
    }
  })])])]), _vm._v(" "), _c('popup', {
    attrs: {
      "labels": _vm.labels,
      "nowLang": _vm.nowLang,
      "labelsButton": _vm.labelsButton,
      "detailTab2Popup": _vm.detailTab2Popup,
      "detailTab2PopupColumns": _vm.detailTab2PopupColumns,
      "setAddCodcours": _vm.setAddCodcours
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-78b0139d!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/hrms75e/detailTab2.vue
// module id = 3901
// module chunks = 1